<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <b-row>
      <user-type-form-field
        class="col-md-4"
        :label="$t('person.fields.type')"
        required
        :value="value.type"
        :error="findError('type')"
        :disabled="disabled || !value.permissions.changeType"
        @input="propertyChange('type', $event)"
      />

      <provider-form-field
        v-if="value.type === 'PROVIDER'"
        class="col-md-8"
        :label="$t('person.fields.provider')"
        required
        :value="value.provider"
        :error="findError('provider')"
        :disabled="disabled || !value.permissions.changeProvider"
        @input="propertyChange('provider', $event)"
      />

      <customer-form-field
        v-if="value.type === 'CUSTOMER'"
        class="col-md-8"
        :label="$t('person.fields.customer')"
        required
        :value="value.customer"
        :error="findError('customer')"
        :disabled="disabled || !value.permissions.changeCustomer"
        @input="propertyChange('customer', $event)"
      />

      <network-form-field
        v-if="value.type === 'BROKER'"
        class="col-md-8"
        :label="$t('person.fields.network')"
        required
        :value="value.network"
        :error="findError('network')"
        :disabled="disabled || !value.permissions.changeNetwork"
        @input="propertyChange('network', $event)"
      />
    </b-row>

    <b-row>
      <string-form-field
        class="col-md-6"
        :label="$t('person.fields.lastName')"
        required
        :value="value.lastName"
        :error="findError('lastName')"
        :disabled="disabled"
        @input="propertyChange('lastName', $event)"
      />

      <string-form-field
        class="col-md-6"
        :label="$t('person.fields.firstName')"
        required
        :value="value.firstName"
        :error="findError('firstName')"
        :disabled="disabled"
        @input="propertyChange('firstName', $event)"
      />
    </b-row>

    <string-form-field
      :label="$t('person.fields.email')"
      required
      :value="value.email"
      :error="findError('email')"
      :disabled="disabled"
      @input="propertyChange('email', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import NetworkFormField from "@/modules/network/protected/NetworkFormField";
import ProviderFormField from "@/modules/provider/protected/ProviderFormField";
import CustomerFormField from "@/modules/customer/protected/CustomerFormField";
import UserTypeFormField from "@/modules/user/protected/UserTypeFormField";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    NetworkFormField,
    ProviderFormField,
    CustomerFormField,
    UserTypeFormField
  }
};
</script>
